import { ErrorState, LoadingState } from '../../components/ui/Feedback';
import { ApiError } from '../../lib/api-client';
import type { BillableAdmission } from './billable-admission';
import { useIpdBills } from './ipd-daycare.queries';
import { currency, formatIpdDateTime } from './ipd-daycare.utils';

export const IpdAllRefundList = ({ admission }: { admission: BillableAdmission }) => {
  const query = useIpdBills(admission.id);
  if (query.isLoading) return <LoadingState />;
  if (query.isError) return <ErrorState title="Unable to load refunds" message={query.error instanceof ApiError ? query.error.message : 'Please try again.'} action={{ label: 'Try again', onClick: () => void query.refetch() }} />;
  const bills = query.data ?? [];
  const refunds = bills.flatMap((bill) => bill.refunds.map((refund) => ({ bill, refund })));
  const totalRefunded = refunds.reduce((sum, item) => sum + item.refund.amount, 0);

  return (
    <>
      <header className="opd-bill-banner">
        <div className="opd-bill-banner-row"><span>All Refund — {admission.patientSnapshot.name}</span></div>
        <p>{admission.admissionLabel} · {refunds.length} refund{refunds.length === 1 ? '' : 's'}</p>
      </header>
      <section className="opd-bill-subsection">
        <div className="opd-bill-subsection-head"><h3>Refunds across all bills</h3><span>Total Refunded <strong>{currency(totalRefunded)}</strong></span></div>
        {refunds.length === 0 ? (
          <p className="opd-bill-empty-note">No refunds have been recorded for this admission.</p>
        ) : (
          <div className="table-scroll">
            <table className="opd-bill-payment-table">
              <thead><tr><th>#</th><th>Bill No</th><th>Date</th><th>Refund By</th><th>Amount</th></tr></thead>
              <tbody>
                {refunds.map((item, index) => (
                  <tr key={item.refund.id}>
                    <td>{index + 1}</td>
                    <td>{item.bill.billNumber}</td>
                    <td>{formatIpdDateTime(item.refund.date)}</td>
                    <td>{item.refund.createdBy.name}</td>
                    <td>{currency(item.refund.amount)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </>
  );
};
